import React from "react";

export default function SQL_Dates() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Dates</h1>
      <p>This is the SQL_Dates component generated from the SQL JSON.</p>
    </div>
  );
}
